module.exports = __webpack_public_path__ + "media/images/logo/Oneticket_tour__white_small-a809d7ab1876c64539f886467d11ce7a.svg";